import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { SAVE_SUCCESS_EVENT } from '../utils/saveNotification';
import { t, useLocale } from '../localization/adminText';
import './SaveSuccessToast.css';

export default function SaveSuccessToast() {
  useLocale();
  const [notice, setNotice] = useState(null);
  const sequence = useRef(0);
  useEffect(() => {
    const show = event => setNotice({ id: ++sequence.current, message: event.detail });
    window.addEventListener(SAVE_SUCCESS_EVENT, show);
    return () => window.removeEventListener(SAVE_SUCCESS_EVENT, show);
  }, []);
  useEffect(() => {
    if (!notice) return;
    const timer = setTimeout(() => setNotice(null), 4000);
    return () => clearTimeout(timer);
  }, [notice]);

  // The app-level host survives closing editors and navigating between pages.
  return createPortal(<div className="save-success-region" role="status" aria-live="polite" aria-atomic="true">
    {notice && <div className="save-success-toast" key={notice.id}>
      <span className="save-success-icon" aria-hidden="true">✓</span>
      <span>{t(notice.message)}</span>
      <button type="button" aria-label={t('Close')} onClick={() => setNotice(null)}>×</button>
    </div>}
  </div>, document.body);
}
